"use client"

// Initialize click tracking for buttons and links
const setupClickTracking = (ta: any) => {
  ta.trackLink(
    {
      tag: ["button", "a"], // Track all buttons and links
    },
    "element_click",
    {
      type: "click",
    },
  )
}

// Set up super properties that will be added to all events
const setupSuperProperties = (ta: any) => {
  ta.setSuperProperties({
    page_url: window.location.href,
    page_path: window.location.pathname,
    page_title: document.title,
    referrer: document.referrer,
  })

  // Set dynamic properties that will be evaluated at the time of each event
  ta.setDynamicSuperProperties(() => ({
    current_url: window.location.href,
    current_path: window.location.pathname,
    current_title: document.title,
  }))
}

let tdAnalytics: any = null

// Check if we're in a development or local environment
const isDevOrLocal = () => {
  if (typeof window === "undefined") return false
  return (
    process.env.NEXT_PUBLIC_ENV === "development" ||
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  )
}

const checkEnvExists = () => {
  if (!process.env.NEXT_PUBLIC_THINKINGDATA_APP_ID || !process.env.NEXT_PUBLIC_THINKINGDATA_SERVER_URL) {
    console.warn("ThinkingData env is not set")
    return false
  }
  return true
}

// Initialize ThinkingData
export const initializeAnalytics = async () => {
  if (!checkEnvExists()) {
    return null
  }
  // Ensure we're in a browser environment
  if (typeof window === "undefined") return null

  // Check if analytics is already initialized to prevent double initialization
  if ((window as any).__TA_initialized) return tdAnalytics
  try {
    // Dynamically import the SDK only on client side
    const ThinkingData = await import("thinkingdata-browser")
    tdAnalytics = ThinkingData.default

    tdAnalytics.init({
      appId: process.env.NEXT_PUBLIC_THINKINGDATA_APP_ID || "",
      serverUrl: process.env.NEXT_PUBLIC_THINKINGDATA_SERVER_URL || "",
      showLog: isDevOrLocal(),
      // Optional configuration
      autoTrack: {
        pageShow: true, // Will track ta_page_show event
        pageHide: true, // Will track ta_page_hide event
      },
      // Enable debug mode in development
      enableLog: isDevOrLocal(),
    })

    // Set up super properties
    setupSuperProperties(tdAnalytics)

    // Set up click tracking
    setupClickTracking(tdAnalytics)

    // Mark as initialized
    ;(window as any).__TA_initialized = true
    return tdAnalytics
  } catch (error) {
    console.error("Failed to initialize ThinkingData:", error)
    return null
  }
}

export const getAnalytics = () => {
  if (typeof window === "undefined") return null
  return tdAnalytics
}
